<template>
  <div>
    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-[16px]">
      <div
        class="tw-flex tw-items-center tw-gap-[10px] tw-grow tw-h-[55px] tw-ps-[26px] tw-rounded-full tw-bg-[var(--my-white-soft2)] md:tw-bg-[var(--my-search-bg-md)]"
      >
        <icon-search class="tw-w-[21px] tw-h-[21px] tw-shrink-0" />
        <input
          type="text"
          :placeholder="$t('donor_dashboard.my_contacts_placeholder_search', 'Search')"
          :value="searchQuery"
          @input="onSearchQueryDebounced"
          class="tw-w-full tw-p-0 tw-grow-1 tw-border-none tw-text-[18px] tw-tracking-[0.01em] tw-leading-[inherit] tw-bg-transparent tw-outline-none tw-text-inherit placeholder:tw-text-[var(--my-text-color)]"
        />
        <span class="tw-shrink-0">
          <my-dropdown variant="my-contact-filter" />
        </span>
      </div>

      <team-select />
    </div>

    <!-- active filters -->
    <div class="tw-flex tw-flex-wrap tw-justify-end tw-gap-[16px] tw-gap-y-[11px] tw-mt-[18px]">
      <template v-for="(_, key) in filteredStatuses">
        <my-btn
          btnStyle="my-ghost-toggleable my-ghost-toggleable--active-filters"
          :key="statuses[key].nameKey"
          @click="removeFilter(key)"
          showCloseIcon
        >
          {{ $t(statuses[key].nameKey, statuses[key].nameDefault) }}
          ({{ statisticsStatuses[key] || 0 }})
        </my-btn>
      </template>
    </div>
  </div>
</template>

<script>
import iconSearch from "@/views/event-page/icons/search.vue";
import myDropdown from "@/views/dashboard/my-contacts/ui/my-dropdown.vue";
import { statuses, STATUS_KEYS } from "@/views/my-contacts/constants";
import myBtn from "@/views/my-contacts/ui/my-btn.vue";
import { mapState, mapActions } from "vuex";
import debounce from "lodash/debounce";
import teamSelect from "@/views/dashboard/my-contacts/contact-list/contact-list-team-select.vue";

export default {
  data() {
    return {
      statuses,
      STATUS_KEYS,
      search: "",
      loading: true,
      teamLoading: false,
    };
  },

  computed: {
    ...mapState({
      activeSearchFilters: (state) => {
        return state.dashboardMyContacts.searchFilters;
      },
      searchQuery: (state) => {
        return state.dashboardMyContacts.searchQuery;
      },
      statisticsStatuses: (state) => state.dashboardMyContacts.statisticsStatuses,
    }),

    filteredStatuses() {
      return Object.entries(this.activeSearchFilters)
        .filter(([, value]) => value)
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});
    },
  },

  methods: {
    ...mapActions({
      setFilterValues: "dashboardMyContacts/setFilterValues",
      setSearchQuery: "dashboardMyContacts/setSearchQuery",
    }),

    removeFilter(key) {
      const newState = { ...this.activeSearchFilters };
      newState[key] = false;
      this.setFilterValues(newState);
    },

    onSearchQueryDebounced: debounce(function (e) {
      this.setSearchQuery(e.target.value);
    }, 500),
  },

  name: "contact-list-search",

  components: {
    iconSearch,
    myDropdown,
    myBtn,
    teamSelect,
  },
};
</script>
